import api from './api';

class PromotionsService {
  // Get all promotions with filters and pagination
  async getPromotions(params = {}) {
    try {
      const response = await api.get('/promotions', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getPromotionStats() {
    try {
      const response = await api.get('/promotions/stats-promo');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get promotion by ID
  async getPromotion(id) {
    try {
      const response = await api.get(`/promotions/${id}`);
      return response.data.promotion;
    } catch (error) {
      // Handle 501 (not implemented) by returning mock data
      if (error.response?.status === 501) {
        console.warn('Promotion detail endpoint not implemented, returning mock data');
        return this.getMockPromotion(id);
      }
      throw this.handleError(error);
    }
  }

  // Create new promotion
  async createPromotion(data) {
    try {
      const response = await api.post('/promotions', data);
      return response.data.promotion;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Update promotion
  async updatePromotion(id, data) {
    try {
      const response = await api.put(`/promotions/${id}`, data);
      return response.data.promotion;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Delete promotion
  async deletePromotion(id) {
    try {
      const response = await api.delete(`/promotions/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Handle API errors
  handleError(error) {
    if (error.response?.data?.message) {
      return new Error(error.response.data.message);
    } else if (error.message) {
      return new Error(error.message);
    } else {
      return new Error('An unexpected error occurred');
    }
  }
}

export default new PromotionsService();